import type { FaireProductEntity } from "../../entity_types/product";

export const p_8cr8xypu: FaireProductEntity = {
  token: "p_8cr8xypu",
  type: "product",
  name: "Balloon Birthday Greeting Card",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/76419b263bbf77a1f99ea4c939155d7f681da19a91252349aff4b4aa017c2dcd/1525981026.jpg",
  galleryImageUrls: [],
  priceDollars: 4.13,
  description:
    'Happy Birthday To You Balloon Card\nFeatures Hand Lettering and Illustrations by Alexa Zurcher \nCard Details: One A2 card included (5.5" x 4.25" when folded), blank inside, professionally printed and packaged in a clear cello sleeve, includes matching envelope, and shipped in a sturdy stay flat mailer.',
  tags: [],
  msrpDollars: 8.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:00.518Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
